/**
  * @typedef {Object} DeliverableDraftSubmission
  * @property {String} id
  * @property {String} draftId
  * @property {Number} version
  * @property {String} submittedAt
  * @property {String} assetUrl
  * @property {String} type
  * @property {String} fileType - The mime fileType of the submitted file
  * @property {String} caption
  * @property {Boolean} emailSent
  * @property {String} status
  * @property {String} createdAt
  * @property {String} updatedAt
  *
  * @typedef {Object} DeliverableDraftObject
  * @type {Object}
  * @property {String} id
  * @property {String} infUid
  * @property {Number} deliverableId
  * @property {Number} projectId
  * @property {String} createdAt
  * @property {String} updatedAt
  * @property {Array.<DeliverableDraftSubmission>} submissions
  */
export class DeliverableDraft {
    /**
     * Create a DeliverableDraft
     * @param {DeliverableDraftObject} draft - The wrapped DeliverableDraftObject
     */
    constructor(draft) {
        this.draft = draft;
    }

    get id() {
        return this.draft.id;
    }
    get infUid() {
        return this.draft.infUid;
    }
    get deliverableId() {
        return this.draft.deliverableId;
    }
    get projectId() {
        return this.draft.projectId;
    }
    get createdAt() {
        return this.draft.createdAt;
    }
    get updatedAt() {
        return this.draft.updatedAt;
    }
    get submissions() {
        return this.draft.submissions.map((submission) => ({ ...submission }));
    }

    /**
     * Returns the submission with the highest version value
     * @returns {DeliverableDraftSubmission}
     */
    get latestSubmission() {
        return Array.from(this.draft.submissions).sort((a, b) => (a.version > b.version ? -1 : 1))[0];
    }
}
